// extracted by mini-css-extract-plugin
export var companyLogos = "logos-module--company-logos--6GKm-";
export var companyCard = "logos-module--company-card--O8qJu";
export var companyLogo = "logos-module--company-logo--dxv3b";